// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vMQF","right":"styles_right__3R1TI"};